import { isString } from 'lodash';
import PropTypes from 'prop-types';
// material
import { Box, Typography, Link, Stack } from '@material-ui/core';
//
import { MBreadcrumbs } from './@material-extend';
import Searchbar from '../layouts/dashboard/Searchbar';
// ----------------------------------------------------------------------

HeaderBreadcrumbs.propTypes = {
  links: PropTypes.array,
  action: PropTypes.node,
  heading: PropTypes.string.isRequired,
  headingSx: PropTypes.object,
  moreLink: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  sx: PropTypes.object
};

export default function HeaderBreadcrumbs({ links, action, leftAction, heading, headingSx, moreLink = '' || [], sx, ...other }) {
  return (
    <Stack sx={sx} mb={5} spacing={2}>
      <Stack direction="row" alignItems="center">
        {leftAction && <Box sx={{ flexShrink: 0 }}>{leftAction}</Box>}
        <Box sx={{ flexGrow: 1 }}>
          <Typography variant="h4" gutterBottom sx={headingSx}>
            {heading}
          </Typography>
         {/* {heading !== 'All Project Categories' ? (<MBreadcrumbs links={links} {...other} />)
         :(null)} */}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Stack>

      {isString(moreLink) ? (
        <Link href={moreLink} target="_blank" variant="body2">
          {moreLink}
        </Link>
      ) : (
        moreLink.map((href) => (
          <Link noWrap key={href} href={href} variant="body2" target="_blank" sx={{ display: 'flex' }}>
            {href}
          </Link>
        ))
      )}
    </Stack>
  );
}
